export default __webpack_public_path__ + "static/media/SG-Red-0005.93e3cc66.png";